import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";
import { capture } from "../lib/analytics";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          capture("invoice_paid", {
            amount_gbp: data.amount_total ? data.amount_total / 100 : undefined,
            session_id: sessionId,
          });
          setState("paid");
          return;
        }
        if (data.status === "expired") { setState("failed"); return; }
      } catch (e) { console.warn("[payment] status poll failed:", e); }
      attempts++;
      if (attempts < 6) setTimeout(poll, 2000); else setState("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {state === "checking" && (<>
        <Loader2 className="mx-auto animate-spin text-[#E8C37A]" size={42} />
        <h1 className="font-display text-4xl text-[#5D2C8F] mt-4">Checking your payment…</h1>
      </>)}
      {state === "paid" && (<>
        <CheckCircle2 className="mx-auto text-[#8EC9C7]" size={56} />
        <h1 className="font-display text-4xl text-[#5D2C8F] mt-4">Payment received — welcome aboard!</h1>
        <p className="text-[#5A4A6B] mt-4">Your welcome pack is on its way. See you in the studio.</p>
        <Link to="/" className="sac-btn-primary mt-7 inline-flex">Back to home</Link>
      </>)}
      {state === "failed" && (<>
        <XCircle className="mx-auto text-[#A685BD]" size={56} />
        <h1 className="font-display text-4xl text-[#5D2C8F] mt-4">We couldn't confirm the payment.</h1>
        <p className="text-[#5A4A6B] mt-4">No charges were made. Please try again or pay by bank transfer.</p>
        <Link to="/schedule" className="sac-btn-secondary mt-7 inline-flex">Back to schedule</Link>
      </>)}
    </div>
  );
}
